export default __webpack_public_path__ + "retail.0cbead194d43ffee4c45.svg";